import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HierarchyDropdownService {
  public sortItemsByText(node): void {
    if (!node.children) {
      return;
    }

    node.children.sort(this._textComparator);

    for (const child of node.children) {
      this.sortItemsByText(child);
    }
  }

  private _textComparator(a, b): number {
    return a.text.toLocaleLowerCase().localeCompare(b.text.toLocaleLowerCase());
  }
}
